import { useSelector } from 'react-redux'

// Types
import { UserSong, UserSongRevenueReport, State, RevenueReportingPeriod } from 'types'

// Utils
import formatDate from 'lib/formatdate'

import styles from './reportinfo.css'

type ReportInfoProps = {
  userSong: UserSong
}

const ReportInfo = ({ userSong }: ReportInfoProps): JSX.Element | null => {
  const revenueReportPeriods = useSelector<State, Array<RevenueReportingPeriod>>(state =>
    Object.values(state.entities.revenueReportPeriods),
  )
  const userSongRevenueReports = useSelector<State, Array<UserSongRevenueReport>>(state =>
    userSong.revenue_reports.map(id => state.entities.userSongRevenueReports[String(id)]),
  )

  const sortedRevenueReports = userSongRevenueReports
    .filter(report => !!report)
    .sort(
      ({ period: { reporting_close: reportingCloseA } }, { period: { reporting_close: reportingCloseB } }) =>
        new Date(reportingCloseB).getTime() - new Date(reportingCloseA).getTime(),
    )
  const openRevenueReports = sortedRevenueReports.filter(({ reported }) => reported)
  const todayDate = new Date()
  const currentlyOpenReport = openRevenueReports.find(
    ({ paid, period }) => !paid && todayDate >= new Date(period.reporting_open) && todayDate <= new Date(period.reporting_close),
  )

  if (currentlyOpenReport && !currentlyOpenReport.reported) {
    return (
      <>
        <p className={styles.titleActive}>Revenue report required</p>
        <p className={styles.subtitle}>Revenue report is due {formatDate(currentlyOpenReport.period.reporting_close)}</p>
      </>
    )
  }
  const nowDate = new Date()
  const currentPeriod = revenueReportPeriods.find(
    ({ start_date, end_date }) => new Date(start_date).getTime() <= nowDate.getTime() && new Date(end_date).getTime() >= nowDate.getTime(),
  ) as RevenueReportingPeriod

  return (
    <>
      <p className={styles.titleActive}>Reporting closed</p>
      <p className={styles.subtitle}>Next reporting period opens {formatDate(currentPeriod.reporting_open)}.</p>
    </>
  )
}

export default ReportInfo
